import { render, staticRenderFns } from "./LeftBackButton.vue?vue&type=template&id=ed2bb5e8&scoped=true"
import script from "./LeftBackButton.vue?vue&type=script&lang=js"
export * from "./LeftBackButton.vue?vue&type=script&lang=js"
import style0 from "./LeftBackButton.vue?vue&type=style&index=0&id=ed2bb5e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2bb5e8",
  null
  
)

export default component.exports